export const mailClient = `<!DOCTYPE html>
    <html lang="es">
    <head>
      <meta charset="UTF-8">
      <title>Confirmación de Reclamo - Biabo Inmobiliaria</title>
      <style>
        body {
          font-family: Arial, Helvetica, sans-serif;
          background-color: #f8f9fa;
          color: #333333;
          margin: 0;
          padding: 0;
        }
        .container {
          background-color: #ffffff;
          max-width: 600px;
          margin: 40px auto;
          padding: 30px;
          border-radius: 10px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }
        .header {
          text-align: center;
          border-bottom: 2px solid #00224e;
          padding-bottom: 15px;
          margin-bottom: 25px;
        }
        .header h1 {
          color: #00224e;
          font-size: 22px;
          margin: 0;
        }
        p {
          line-height: 1.6;
          font-size: 15px;
          margin-bottom: 15px;
        }
        .footer {
          font-size: 13px;
          color: #777;
          text-align: center;
          border-top: 1px solid #e0e0e0;
          margin-top: 30px;
          padding-top: 10px;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <p>Estimado(a) cliente,</p>
        <p>
          Hemos recibido correctamente su reclamo registrado en nuestro 
          <strong>Libro de Reclamaciones Virtual</strong>.
        </p>
        <p>
          Nuestro equipo revisará su solicitud y le brindará una respuesta lo antes posible.
        </p>
        <p>Atentamente,<br><strong>Biabo Inmobiliaria</strong></p>
        
      </div>
    </body>
    </html>`;

export const emailMaster = `
    <!DOCTYPE html>
    <html lang="es">
    <head>
      <meta charset="UTF-8">
      <title>Nuevo Reclamo Registrado</title>
      <style>
        body {
          font-family: Arial, Helvetica, sans-serif;
          background-color: #f4f6f8;
          color: #333333;
          margin: 0;
          padding: 0;
        }
        .container {
          background-color: #ffffff;
          max-width: 600px;
          margin: 40px auto;
          padding: 30px;
          border-radius: 10px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
          line-height: 1.6;
          font-size: 15px;
        }
        a {
          color: #0069b4;
          text-decoration: none;
        }
        a:hover {
          text-decoration: underline;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <p>Estimado equipo,</p>

        <p>Se ha registrado un nuevo reclamo a través del Libro de Reclamaciones Virtual del sitio web. Se adjunta el archivo PDF con la información completa registrada por el cliente.</p>

        <p>Por favor, revise y gestione el caso según los procedimientos internos y los plazos establecidos por el Código de Protección y Defensa del Consumidor.</p>

        <p>Para ver todos los reclamos ingrese con su cuenta aquí 
          (<a href="https://docs.google.com/spreadsheets/d/1zTBhRccGsbyRSccOY-RA9MlelZ-ZLS1WHkFgo77VCiA/edit?gid=0#gid=0" target="_blank">
            https://docs.google.com/spreadsheets/d/1zTBhRccGsbyRSccOY-RA9MlelZ-ZLS1WHkFgo77VCiA/edit?gid=0#gid=0
          </a>)
        </p>

        <p>Atentamente,<br>
        Sistema de Libro de Reclamaciones Virtual<br>
        Fórmula Agencia de marketing</p>
      </div>
    </body>
    </html>
  `;
